module.exports = __webpack_public_path__ + "img/div5s.3253d052.jpg";